import { rruleSchema } from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { z } from 'zod';
import http from '@/utils/http.service';

const stopRecurrenceAgendaSlotResponseSchema = z.object({
  id: z.string().uuid(),
  rrule: rruleSchema,
});

export type StopRecurrenceAgendaSlotResponse = z.infer<
  typeof stopRecurrenceAgendaSlotResponseSchema
>;
export type StopRecurrenceAgendaSlotPayload = {
  id: string;
  until: string;
  occurrenceIndex: number;
};

const stopRecurrenceAgendaSlot = (payload: StopRecurrenceAgendaSlotPayload) => {
  return http.agendaSlots
    .stopRecurrence(payload.id, {
      until: payload.until,
      occurrenceIndex: payload.occurrenceIndex,
    })
    .then<StopRecurrenceAgendaSlotResponse>(({ response, transform }) => {
      return transform.handle({
        response,
        attributes: {
          rrule: true,
        },
        schema: stopRecurrenceAgendaSlotResponseSchema,
      });
    });
};

const useStopRecurrenceAgendaSlotMutation = (): UseMutationResult<
  StopRecurrenceAgendaSlotResponse,
  Error,
  StopRecurrenceAgendaSlotPayload
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: stopRecurrenceAgendaSlot,
    onSuccess() {
      toast.success(t('http.stop-recurrence-agenda-slot.success'));
    },
  });
};

export default useStopRecurrenceAgendaSlotMutation;
